import ValidationResult from "./ValidationResult";

/**
 * class ConstrainBase
 */
class ConstrainBase {

  validate(_value) {
    return new ValidationResult(true, '');
  }
}

export default ConstrainBase;
